import router from './router'
import {
    clearHcUserInfo,
    clearHealthCare,
    getAuthToken,
    getHealthCare,
    getWxInfo,
    setHealthCare
} from "@/utils/storage";
import {wxAuthLogin} from "@/utils/wxLogin";
/* eslint-disable no-new */
// 路由拦截，判断是否需要登录
/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
    if (to.path === '/home/healthCare'
        || (to.path === '/account/register' && to.query.isFromHcApp === '1')
        || (to.path === '/home/homepage' && to.query.encData)
        || to.path === '/transitPage'
        || (to.path === '/outpatientPrescription' && to.query.encData)
        || to.path === '/payResult'
        || (to.path === '/confirmationAppointment' && to.query.isFromHcApp)) {
        setHealthCare()
    } else if (to.path.indexOf('/home/homeneirong') > -1) {
        clearHcUserInfo()
        clearHealthCare()
    }
    if (getHealthCare() === '1') {
        next()
    } else {
        if (to.path === '/not' || (to.path === '/home/homepage' && to.query.directAccess === 'yes')) {
            next()
            return
        }
        // 需同时具备微信用户缓存与后端鉴权 token
        if (!getWxInfo().openid || !getAuthToken()) {
            wxAuthLogin(to.fullPath)
        } else {
            next()
        }
    }
});

router.onError((error) => {
    const jsPattern = /Loading chunk (\S)+ failed/g
    const cssPattern = /Loading CSS chunk (\S)+ failed/g
    const isChunkLoadFailed = error.message.match(jsPattern || cssPattern)
    const targetPath = router.history.pending.fullPath
    if (isChunkLoadFailed) {
        localStorage.setItem('targetPath', targetPath)
        window.location.reload()
    }
})



// WEBPACK FOOTER //
// ./src/permission.js